import { useState } from "react"
import { Textareawithsteroids, Textareawithsteroids2 } from "../ESG/EnvironmentReport"
import { HeaderShow } from "../ESG/ESGmain"

const Step4 = () => {
    const [showContent,setShowContent] = useState(false)
    const subtext = `Only choose to work with SDG where you really can make a difference, otherwise this is not for you. If you have: an enterprise risk analysis, materiality assessment or LCA's on your products and intermediate resources, they are of great use here. If you do not have it you can go to the education tab and learn more, subsequently to the ambition tab and find some frameworks to help you get strated with one of them.
    
But do not get swamped here - we want to find out which areas are of importance to the business and the valuechain, relative to company size and influence. THis is a longterm investment for measureable strategic effect on the business and the SDG`

    const actiontext = `Map critical materials and resources that goes into your products and support those parts of the value chain, note what influence it can have on the future of the business, how will the choice of the given SDG change the way you do business.`
    const exercisetext = `The goals will and should change the way we do busness today, therefore Top management must be firestarters on the strategic relevance and implementation. This is a business area as all others and will entail investment, rentability and this, not least, entails measurement over time to see that the effort pays off. Get preliminary thoughts on metrics`
    return ( 
        <div className="d-flex flex-column align-items-center mt-2">
        <HeaderShow text={"Step 4 Assess"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
        
        {
            showContent ?
            <>
            <div className="roleambition__bubble w-90 mt-3 ms-0">
                <h5>{subtext}</h5>
                <div className="d-flex justify-content-between mt-2">
                    <div className="d-flex flex-column me-5">
                        <h5 style={{textAlign:"center"}}><b>Action</b></h5>
                        <h5>{actiontext}</h5>
                    </div>
                    <div className="d-flex flex-column">
                        <h5 style={{textAlign:"center"}}><b>Exercise</b></h5>
                        <h5>{exercisetext}</h5>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-around w-90">
                <div className="sdg__action__exercise">
                    <h4>Action:</h4><Textareawithsteroids2   
                        maxLength={3000}
                        keyHighlight={"step4_action"}
                    />        
                </div>
                <div className="sdg__action__exercise">
                    <h4>Exercise:</h4><Textareawithsteroids2   
                        maxLength={3000}
                        keyHighlight={"step4_exercise"}
                    />        
                </div>
            </div>
            <div className="sdg__action__exercise w-85">
                <h4>Write in your conclusions here:</h4><Textareawithsteroids2   
                    maxLength={3000}
                    keyHighlight={"step4_conclusion"}
                />        
            </div>
            </>:null
        }
        </div>
     );
}
 
export default Step4;